/* eslint-disable max-len */
import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { SCRATCHPAY_ACCOUNT_URL } from "../../config/params";

const scratchPayLogo = "/assets/icons/scratchpay.png";

const ScratchPayPaymentMethod = () => {
  const handleClick = () => {
    window.open(SCRATCHPAY_ACCOUNT_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <Box
      className= "flex items-center justify-between bg-white p-3 rounded-lg border border-taupe-50 cursor-pointer hover:bg-gray-50 transition-colors"
      onClick={handleClick}
    >
      <Box className="flex items-center gap-3">
        <Box
          className="flex items-center justify-center h-8 px-1.5 rounded-md"
          sx={{ backgroundColor: "whiteWarm.main" }}
        >
          <img
            src={scratchPayLogo}
            alt="ScratchPay"
            className="h-[15px] w-14 object-contain"
          />
        </Box>
        <Typography variant="body1" sx={{ fontWeight: 600 }}>
          ScratchPay
        </Typography>
      </Box>
      <ChevronRightIcon sx={{ color: "gray.dark" }} />
    </Box>
  );
};

export default ScratchPayPaymentMethod;

